import moment from 'moment'
import {useIntl} from 'react-intl'
import {formatPhoneNumber} from 'src/feature/bite/helpers/phone'
import {useMember} from '../../hook'

export default function MemberDetailOverview() {
  const intl = useIntl()
  const {detail} = useMember()

  // const statusOptions = [
  //   { value: true, label: intl.formatMessage({ id: 'ACTIVE' }) },
  //   { value: false, label: intl.formatMessage({ id: 'PASSIVE' }) },
  // ];

  // const customerGroupOptions = [
  //   { value: '1', label: 'Group 1' },
  //   { value: '2', label: 'Group 2' },
  //   { value: '3', label: 'Group 3' },
  //   { value: '4', label: 'Group 4' },
  // ];

  return (
    <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
      <div className='card-header'>
        <div className='card-title m-0 d-flex justify-content-between w-100'>
          <div>
            <h3 className='fw-bold mb-2 mt-5'>
              {intl.formatMessage({id: 'MEMBER.DETAIL.OVERVIEW'})}
            </h3>
            <p className='text-muted fw-normal fs-6'>
              {intl.formatMessage({id: 'MEMBER.DETAIL.OVERVIEW_TOOLTIP'})}
            </p>
          </div>
        </div>
      </div>

      <div className='card-body p-9'>
        {/*         <div className='row mb-10'>
          <div className='d-flex flex-column flex-grow-1 pe-8'>
            <div className='d-flex flex-wrap'>
              <div className='rounded min-w-125px py-3 px-4 me-6 mb-3 text-light bg-primary bg-gradient'>
                <div className='d-flex align-items-center'>
                  <div
                    className='fs-2 fw-bold'
                    data-kt-countup='true'
                    data-kt-countup-value='0.00'
                    data-kt-countup-decimal-places='2'
                  >
                    <NumericFormat
                      value={detail?.netPoints?.toFixed(2)}
                      allowLeadingZeros
                      thousandSeparator=','
                      displayType='text'
                    />
                  </div>
                </div>

                <div className='fw-semibold fs-6'>
                  {intl.formatMessage({id: 'MEMBER.DETAIL.OVERVIEW.NET_POINTS'})}
                </div>
              </div>

              <div className='rounded min-w-125px py-3 px-4 me-6 mb-3 text-light bg-primary bg-gradient'>
                <div className='d-flex align-items-center'>
                  <div
                    className='fs-2 fw-bold'
                    data-kt-countup='true'
                    data-kt-countup-value='0.00'
                    data-kt-countup-decimal-places='2'
                    data-kt-countup-prefix='AED'
                  >
                    <span>AED </span>{' '}
                    <NumericFormat
                      value={detail?.worth.toFixed(2)}
                      allowLeadingZeros
                      thousandSeparator=','
                      displayType='text'
                    />
                  </div>
                </div>

                <div className='fw-semibold fs-6'>
                  {intl.formatMessage({id: 'MEMBER.DETAIL.OVERVIEW.WORTH'})}
                </div>
              </div>

              <div
                className='rounded min-w-125px py-3 px-4 me-6 mb-3 text-light'
                style={{background: '#00a3c4'}}
              >
                <div className='d-flex align-items-center'>
                  <div
                    className='fs-2 fw-bold'
                    data-kt-countup='true'
                    data-kt-countup-value='0.00'
                    data-kt-countup-decimal-places='2'
                  >
                    <NumericFormat
                      value={detail?.totalEarnings.toFixed(2)}
                      allowLeadingZeros
                      thousandSeparator=','
                      displayType='text'
                    />
                  </div>
                </div>

                <div className='fw-semibold fs-6'>
                  {intl.formatMessage({id: 'MEMBER.DETAIL.OVERVIEW.TOTAL_EARNINGS'})}
                </div>
              </div>

              <div
                className='rounded min-w-125px py-3 px-4 me-6 mb-3 text-light'
                style={{background: '#00a3c4'}}
              >
                <div className='d-flex align-items-center'>
                  <div
                    className='fs-2 fw-bold'
                    data-kt-countup='true'
                    data-kt-countup-value='0.00'
                    data-kt-countup-decimal-places='2'
                    data-kt-countup-prefix='AED'
                  >
                    <span>AED </span>
                    <NumericFormat
                      value={detail?.savings.toFixed(2)}
                      allowLeadingZeros
                      thousandSeparator=','
                      displayType='text'
                    />
                  </div>
                </div>

                <div className='fw-semibold fs-6'>
                  {intl.formatMessage({id: 'MEMBER.DETAIL.OVERVIEW.TOTAL_SAVINGS'})}
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className='row'>
          <div className='col'>
            <div className='column mb-7'>
              <label className='col-lg-4 fw-semibold text-muted'>
                {intl.formatMessage({id: 'MEMBER.DETAIL.OVERVIEW.MEMBER_ID'})}
              </label>

              <div className='col-lg-8'>
                <span className='fw-bold fs-6 text-gray-800'>{detail?.memberId}</span>
              </div>
            </div>

            {/*    <div className='column mb-7'>
              <label className='col-lg-4 fw-semibold text-muted'>
                {intl.formatMessage({id: 'MEMBER.DETAIL.OVERVIEW.MEMBER_ID_EXTERNAL'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <span className='fw-semibold text-gray-800 fs-6'>{detail?.externalMemberId}</span>
              </div>
            </div> */}

            <div className='column mb-7'>
              <label className='col-lg-4 fw-semibold text-muted'>
                {intl.formatMessage({id: 'MEMBER.DETAIL.OVERVIEW.FIRST_NAME'})}
              </label>

              <div className='col-lg-8'>
                <span className='fw-semibold fs-6 text-gray-800 text-hover-primary'>
                  {detail?.name}
                </span>
              </div>
            </div>

            <div className='column mb-7'>
              <label className='col-lg-4 fw-semibold text-muted'>
                {intl.formatMessage({id: 'MEMBER.DETAIL.OVERVIEW.LAST_NAME'})}
              </label>

              <div className='col-lg-8'>
                <span className='fw-bold fs-6 text-gray-800'>{detail?.surname}</span>
              </div>
            </div>

            <div className='column mb-7'>
              <label className='col-lg-4 fw-semibold text-muted'>
                {intl.formatMessage({id: 'MEMBER.DETAIL.OVERVIEW.DATE_OF_BIRTH'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <span className='fw-semibold text-gray-800 fs-6'>
                  {detail?.birthDate && moment.utc(detail?.birthDate).format('DD/MM/YYYY')}
                </span>
              </div>
            </div>

            {/* <div className='column mb-7'>
              <label className='col-lg-4 fw-semibold text-muted'>
                {intl.formatMessage({id: 'MEMBER.DETAIL.OVERVIEW.CUSTOMER_GROUP'})}
              </label>

              <div className='col-lg-4 mt-2'>
                <span className='fw-semibold text-gray-800 fs-6'>{detail?.customerGroup}</span>
                <Select
                  className="custom-select"
                  options={customerGroupOptions}
                  value={customerGroupOptions.find((s) => s.value === detail?.customerGroup)}
                /> 
               <select
                  className='form-select form-select-solid'
                  data-control='select2'
                  data-placeholder='Select an option'
                  data-hide-search='true'
                  value={detail?.customerGroup}
                  disabled
                >
                  <option></option>
                  <option value='Customer group'>Group 1</option>
                  <option value='2'>Group 2</option>
                  <option value='3'>Group 3</option>
                </select>
              </div>
            </div> */}

            {/* <div className='column mb-7'>
              <label className='col-lg-4 fw-semibold text-muted'>Preferred Language</label>
              <div className='col-lg-4 mt-2'>
                <span className='fw-semibold text-gray-800 fs-6'>
                  {languages.find((s) => s.value === detail?.preferredLanguage)?.label}
                </span> */}
            {/* <Select
                  className="custom-select"
                  options={preferredLanguageOptions}
                  value={preferredLanguageOptions.find((s) => s.value === detail?.preferredLanguage)}
                /> */}
            {/* <select
                  className='form-select form-select-solid'
                  data-control='select2'
                  data-placeholder='Select an option'
                  data-hide-search='true'
                  value={detail?.preferredLanguage}
                  disabled
                >
                  <option></option>
                  <option value='en-US'>EN</option>
                  <option value='de-DE'>DE</option>
                  <option value='tr-TR'>TR</option>
                </select> */}
            {/* </div>
            </div> */}
          </div>
          <div className='col'>
            {/* <div className='column mb-7'>
              <label className='col-lg-4 fw-semibold text-muted'>
                {intl.formatMessage({id: 'MEMBER.DETAIL.OVERVIEW.GENDER'})}
              </label>

              <div className='col-lg-8'>
                <span className='fw-bold fs-6 text-gray-800'>
                  {detail?.gender === 1 ? 'Male' : 'Female'}{' '}
                </span>
              </div>
            </div> */}

            <div className='column mb-7'>
              <label className='col-lg-4 fw-semibold text-muted'>
                {intl.formatMessage({id: 'MEMBER.DETAIL.OVERVIEW.STATUS'})}
              </label>

              <div className='col-lg-4 d-flex align-items-center mt-2'>
                {detail?.status === 1 ? (
                  <span className='fw-semibold text-success fs-6'>
                    {intl.formatMessage({id: 'GLOBAL.ACTIVE'})}
                  </span>
                ) : detail?.status === 2 ? (
                  <span className='fw-semibold text-danger fs-6'>
                    {intl.formatMessage({id: 'GLOBAL.INACTIVE'})}
                  </span>
                ) : detail?.status === 283630000 ? (
                  <span className='fw-semibold text-danger fs-6'>
                    {intl.formatMessage({id: 'GLOBAL.PREACTIVE'})}
                  </span>
                ) : (
                  <span className='fw-semibold text-danger fs-6'>-</span>
                )}

                {/* <Select
                  className="custom-select"
                  options={statusOptions}
                  value={statusOptions.find((s) => s.value === detail?.status)}
                /> */}
                {/* <select
                  className='form-select form-select-solid'
                  data-control='select2'
                  data-placeholder='Select an option'
                  data-hide-search='true'
                  value={detail?.status ? '2' : '3'}
                  disabled
                >
                  <option></option>
                  <option value='2'>
                    {intl.formatMessage({ id: 'ACTIVE' })}
                  </option>
                  <option value='3'>
                    {intl.formatMessage({ id: 'PASSIVE' })}
                  </option>
                </select> */}
              </div>
            </div>
            {/* 
            <div className='column mb-7'>
              <label className='col-lg-4 fw-semibold text-muted'>
                {intl.formatMessage({id: 'MEMBER.DETAIL.OVERVIEW.LAST_NAME'})}
              </label>

              <div className='col-lg-8'>
                <span className='fw-bold fs-6 text-gray-800'>{detail?.surname}</span>
              </div>
            </div> */}

            <div className='column mb-7'>
              <label className='col-lg-4 fw-semibold text-muted'>
                {intl.formatMessage({id: 'MEMBER.DETAIL.OVERVIEW.EMAIL'})}
              </label>

              <div className='col-lg-8'>
                <span className='fw-semibold fs-6 text-gray-800 text-hover-primary'>
                  {detail?.email}
                </span>
              </div>
            </div>

            <div className='column mb-7'>
              <label className='col-lg-4 fw-semibold text-muted'>
                {intl.formatMessage({id: 'MEMBER.DETAIL.OVERVIEW.MOBILE_PHONE'})}
              </label>

              <div className='col-lg-8 d-flex align-items-center'>
                <span className='fw-bold fs-6 text-gray-800 me-2'>
                  {detail?.countryCode && detail?.countryCode !== '971'
                    ? `+${detail?.countryCode} ${detail?.mobile}`
                    : formatPhoneNumber(detail?.mobile || '')}
                </span>
              </div>
            </div>

            <div className='column mb-7'>
              <label className='col-lg-4 fw-semibold text-muted'>
                {intl.formatMessage({id: 'MEMBER.LIST.ENROLLMENT_DATE'})}
              </label>

              <div className='col-lg-8'>
                <span className='fw-bold fs-6 text-gray-800'>
                  {moment.utc(detail?.enrollmentDate).format('DD/MM/YYYY HH:mm')}
                </span>
              </div>
            </div>

            {/*             <div className='column mb-7'>
              <label className='col-lg-4 fw-semibold text-muted'>
                {intl.formatMessage({ id: 'MEMBER.DETAIL.OVERVIEW.CUSTOMER_TOKEN' })}
              </label>

              <div className='col-lg-8'>
                <span className='fw-bold fs-6 text-gray-800'>{detail?.customerToken}</span>
              </div>
            </div> */}

            {/*   <div className='column mb-7'>
              <label className='col-lg-4 fw-semibold text-muted'>Second Language</label>

              <div className='col-lg-4 mt-2'>
                <span className='fw-semibold text-gray-800 fs-6'>
                  {languages.find((s) => s.value === detail?.secondLanguage)?.label}
                </span>
                
              </div>
            </div> */}
          </div>
        </div>
      </div>

      {/* <div className='card-footer d-flex w-100 justify-content-end'>
        <a className='btn btn-primary' href='../../demo31/dist/member-edit.html'>
          <i className='bi bi-save2 me-2'></i>
          Update
        </a>
      </div> */}
    </div>
  )
}
